import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { BLOGS } from "@/site";
import SEO, { articleSchema } from "@/components/SEO";
import CTABanner from "@/components/sections/CTABanner";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function BlogPost() {
    const { slug } = useParams();
    const post = BLOGS.find((b) => b.slug === slug);
    if (!post) return <Navigate to="/blog" replace />;

    return (
        <div data-testid={`page-blog-${slug}`}>
            <SEO title={`${post.title} | Ihao Music House Delhi`} description={post.metaDesc} path={`/blog/${slug}`} image={post.image} schema={articleSchema(post)} />
            <Breadcrumbs items={[
                { label: "Home", to: "/" },
                { label: "Blog", to: "/blog" },
                { label: post.title.length > 40 ? post.title.slice(0, 40) + "…" : post.title },
            ]} />

            {/* HERO */}
            <section className="relative py-20 md:py-28 bg-black overflow-hidden">
                <div className="absolute inset-0 bg-radial-gold opacity-40" aria-hidden />
                <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <Link to="/blog" className="text-xs uppercase tracking-[0.3em] text-gold/80 hover:text-gold">← Back to blog</Link>
                    <h1 className="mt-6 font-display text-4xl md:text-6xl font-bold text-white leading-[1.05]">{post.title}</h1>
                    <div className="mt-6 flex items-center gap-3 text-[10px] uppercase tracking-[0.2em] text-white/50">
                        <span>{new Date(post.date).toLocaleDateString("en-IN", { month: "long", day: "numeric", year: "numeric" })}</span>
                        <span className="w-1 h-1 rounded-full bg-white/30" />
                        <span>{post.readTime}</span>
                    </div>
                </div>
            </section>

            <section className="relative py-10 md:py-16 bg-background">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <img src={post.image} alt={post.title} className="w-full aspect-[16/9] object-cover rounded-2xl border border-white/10" />

                    <article className="prose-invert mt-12 space-y-6">
                        <p className="text-lg text-white/80 leading-relaxed">{post.excerpt}</p>
                        {post.body.map(([tag, text], i) => {
                            if (tag === "h2") return <h2 key={i} className="mt-10 font-display text-2xl md:text-3xl text-white font-semibold">{text}</h2>;
                            return <p key={i} className="text-white/70 leading-relaxed">{text}</p>;
                        })}
                    </article>

                    <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                        <div>
                            <div className="text-[10px] uppercase tracking-[0.3em] text-gold">Written by</div>
                            <div className="mt-1 text-white font-semibold font-display text-lg">Ihao Music House Faculty</div>
                        </div>
                        <Link to="/contact" className="inline-flex items-center justify-center bg-gold text-black font-semibold text-sm px-7 py-3.5 rounded-full hover:bg-gold-hover transition-colors">Book Free Trial Class</Link>
                    </div>
                </div>
            </section>

            <CTABanner />
        </div>
    );
}
